import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBoundStore } from '../../Store/store';

const FreelancerApprovalGuard = ({ children }) => {
    const user = useBoundStore(state => state.user);
    const location = useLocation();

    if (user && user.type === 'freelancer' && !user.approved_at) {
        return <Navigate to="/pending-approval" state={{ from: location }} replace />;
    }

    return children;
};

export default FreelancerApprovalGuard;

